// src/utils/request.js
import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: 'http://northwest-bio.com/backend',// 使用环境变量配置基础URL
  // baseURL: 'http://localhost:8888/backend',
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前可以做一些处理
    // 例如：如果有token，可以在这里统一添加
    // if (store.getters.token) {
    //   config.headers['Authorization'] = `Bearer ${getToken()}`
    // }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log('Request Error:', error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果code不是0，则判断为错误
    if (res.code !== 0) {
      // 显示错误提示
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 返回一个拒绝的Promise，这样调用处可以捕获到错误
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      // 如果code是0，直接返回data中的数据
      return res.data
    }
  },
  error => {
    console.log('Response Error:', error) // for debug
    
    // 处理HTTP错误状态码
    let message = error.message
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = '请求错误(400)'
          break
        case 401:
          message = '未授权，请重新登录(401)'
          // 这里可以跳转到登录页面
          break
        case 403:
          message = '拒绝访问(403)'
          break
        case 404:
          message = '请求出错(404)'
          break
        case 408:
          message = '请求超时(408)'
          break
        case 500:
          message = '服务器错误(500)'
          break
        case 501:
          message = '服务未实现(501)'
          break
        case 502:
          message = '网络错误(502)'
          break
        case 503:
          message = '服务不可用(503)'
          break
        case 504:
          message = '网络超时(504)'
          break
        case 505:
          message = 'HTTP版本不受支持(505)'
          break
        default:
          message = `连接出错(${error.response.status})!`
      }
    }
    
    // 注释掉网络错误弹窗
    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })

    return Promise.reject(error)
  }
)

export default service